import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";
import { createOrUpdatePlan } from "../../../api/endpoint";
import axios from "axios";
import Loader from "../../../components/loader";

const AddModal = ({ isAddOpen, closeAddModal, fetchPlans }) => {
  const [plan, setPlan] = useState({
    name: "",
    price: "",
    durationInDays: "",
  });
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  const addPlan = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(createOrUpdatePlan, plan, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
      });
      setPlan({
        name: "",
        price: "",
        durationInDays: "",
      });
      fetchPlans();
      closeAddModal();
    } catch (err) {
      console.error("Add Subscription Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={isAddOpen} onHide={closeAddModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Subscription Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input
            label="Name"
            name="name"
            placeholder="Name"
            type="text"
            value={plan.name}
            onChange={(e) => setPlan({ ...plan, name: e.target.value })}
            className="mb-2"
          />
          <Input
            label="Price"
            name="price"
            placeholder="Price"
            type="text"
            value={plan.price}
            onChange={(e) => setPlan({ ...plan, price: e.target.value })}
            className="mb-2"
          />
          <Input
            label="Duration in Days"
            name="price"
            placeholder="Duration"
            type="text"
            value={plan.durationInDays}
            onChange={(e) =>
              setPlan({ ...plan, durationInDays: e.target.value })
            }
            className="mb-2"
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <Button
              text="Create Subscription Plan"
              callBack={(e) => addPlan(e)}
            />
          </div>
        </Modal.Footer>
      </Modal>
      {loading && <Loader />}
    </>
  );
};

export default AddModal;
